import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TrendingSection from './components/TrendingSection';
import CategoryShowcase from './components/CategoryShowcase';
import ArticleSections from './components/ArticleSections';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久热 - 热门内容持续更新，尽享精彩',
    description: '久久热是您发现热门内容、追踪流行趋势的首选平台。海量精彩内容持续更新，覆盖娱乐、资讯、生活等多元领域。',
    url: 'https://mosquitos.cn',
    isPartOf: {
      '@type': 'WebSite',
      name: '久久热',
      url: 'https://mosquitos.cn',
    },
  };

  return (
    <>
      <SEOHead
        title="首页"
        description="久久热是您发现热门内容、追踪流行趋势的首选平台。海量精彩内容持续更新，覆盖娱乐、资讯、生活等多元领域，让您每天都能找到最热、最新、最有趣的内容。"
        keywords="久久热,久久热最新内容,久久热热门推荐,久久热每日更新,热门趋势内容,精彩内容聚合平台,热门娱乐资讯"
        canonicalUrl="https://mosquitos.cn"
        schemaJson={homeSchema}
      />
      <Navbar />
      <main>
        <Hero />
        <TrendingSection />
        <CategoryShowcase />
        <ArticleSections />
      </main>
      <Footer />
    </>
  );
}